import React, { useEffect, useRef, useState } from "react";
import SummarySection from "./SummarySection";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AIAvtar from "../../assets/svg/AI Avatar.svg";
import SendIcon from "../../assets/svg/sendIcon.svg";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { Link, useNavigate } from "react-router-dom";
import {
  fetchBudgetPricing,
  filterPropertyAPI,
  filterPropertyList,
  userSignup,
} from "../../services/apiServices";
import { useAuthStore } from "../../redux/features/authSlice";
import { setToken } from "../../utils/axiosClient";
import { questions as questionsEn } from "./AiBasicComponent/question";
import { questions as questionsRo } from "./AiBasicComponent/question.ro";
import { UserMessage } from "./AiBasicComponent/UserMessage";
import HistorySection from "./HistorySection";
import { usePropertyStore } from "../../redux/features/propertyDetailSlice";
import { useRedirectStore } from "../../redux/features/userRedirectSlice";
import { ClipLoader } from "react-spinners";
// import { render } from "@testing-library/react";
import { useTranslation } from "react-i18next";

const AiMessage = ({
  resultCount,
  message,
  suggestions,
  allMessages,
  currentQuestionIndex,
  setNewMessage,
  setRender,
  render,
  questions,
}) => {
  const { loginInfo, removeLoginInfo } = useAuthStore();
  const { updateUserRedirectState } = useRedirectStore();
  const navigate = useNavigate;
  const [loading, setLoading] = useState(false);
  const { propertyInfo, updatePropertyInfo } = usePropertyStore();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [docIdState, setDocIdState] = useState("");

  useEffect(() => {
    questions?.map((item, index) => {
      if (item.text == message) {
        setCurrentIndex(index);
      }
    });
  }, []);
  const onSearch = async () => {
    try {
      // Check if suggestions array contains a location
      setToken(loginInfo ? loginInfo?.token : null);
      setLoading(true);
      let payload = {};
      let chk = 0;
      questions?.map((item, index) => {
        // let index=currentQuestionIndex
        if (index == 0) {
          chk = 2;
        }
        if (item.text == message) {
          let q, a, c, k, l;
          if (index > 0) {
            q = questions[index - 1].text;
            k = questions[index - 1].key;
            l = questions[index - 1].label;
            c = questions[index - 1].check;
            chk = c;
            a =
              c == 3
                ? propertyInfo?.furnished?.answer
                : c == 4
                ? propertyInfo?.furnished?.budgetPricing
                : propertyInfo?.furnished?.leaseTermsDuration;
          }

          payload = {
            location: {
              latLng: {
                latitude:
                  index >= 0 ? propertyInfo?.location?.latLng?.latitude : "",
                longitude:
                  index >= 0 ? propertyInfo?.location?.latLng?.longitude : "",
              },
              address: index >= 0 ? propertyInfo?.location?.address : "",
            },
            calculatedSize:
              index >= 0
                ? propertyInfo?.calculatedSize?.size?.length > 0
                  ? propertyInfo?.calculatedSize?.size
                  : [0, 0]
                : "",
            movePlan:
              index >= 1
                ? propertyInfo?.movePlan?.answer
                  ? propertyInfo?.movePlan?.answer
                  : ""
                : "",
            monthlyBudget:
              index >= 2
                ? propertyInfo?.budgetPricing?.answer
                  ? propertyInfo?.budgetPricing?.answer
                  : ""
                : "",
            preferredLocation:
              index >= 3
                ? propertyInfo?.preferredLocation
                  ? propertyInfo?.preferredLocation
                  : ""
                : "",
            officeType:
              index >= 4
                ? propertyInfo?.officeType?.answer
                  ? propertyInfo?.officeType?.answer
                  : ""
                : "",

            leaseTermsDuration:
              index >= 5
                ? propertyInfo?.leaseDuration?.answer
                  ? propertyInfo?.leaseDuration?.answer
                  : ""
                : "",

            // officeSpaces:
            //   index >= 6
            //     ? propertyInfo?.officeSpaces?.answer
            //       ? propertyInfo?.officeSpaces?.answer
            //       : ""
            //     : "",

            parking:
              index >= 6
                ? propertyInfo?.parking?.answer
                  ? propertyInfo?.parking?.answer
                  : ""
                : "",
            key: k,
            check: c,
            questions: q,
            answers: a,
            locationCount: propertyInfo?.location?.locationCount,
            userId: loginInfo?.user?._id,
            docId: propertyInfo?.docIdSearchHistory,
          };
        }
      });
      const response = await filterPropertyAPI(payload);
      if (response?.data?.statusCode == 200) {
        // setResultCount(response?.data?.count);
        setDocIdState(response?.data?.chatHistoryDocId?._id);
        if (chk == 3) {
          updatePropertyInfo({
            ...propertyInfo,
            docIdSearchHistory: response?.data?.chatHistoryDocId?._id,
          });
        }
        setRender(!render);
      } else if (response?.data?.statusCode == 401) {
        toast.warning(
          response?.data?.message || "Your session has been expired.",
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        updateUserRedirectState();
        removeLoginInfo();
        navigate("/");
      } else {
        console.warn("error============ in API gives 401");
      }
    } catch (error) {
      console.warn("error============", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onSearch();
  }, []);

  if (!message) {
    setNewMessage("");
    return "";
  } else {
    setNewMessage(message);
  }
  return (
    <div className="mt-5">
      <div className="flex gap-4 md:max-w-[calc(100%-80px)]">
        {message && currentIndex != questions.length - 1 ? (
          <img src={AIAvtar} alt="AI Avatar" className="w-10 h-10" />
        ) : (
          <div></div>
        )}
        <div>
          <>
            {message && currentIndex != questions.length - 1 && (
              <p className="text-primary-text font-medium text-base">
                {message}
              </p>
            )}
          </>
        </div>
      </div>
    </div>
  );
};

const AiChatSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenHistory, setIsOpenHistory] = useState(false);
  const [isOpenSummary, setIsOpenSummary] = useState(false);
  const autocompleteRef = useRef(null); // Persistent across renders
  const [resultCount, setResultCount] = useState(0);

  const { t, i18n } = useTranslation();
  let questions = questionsRo;
  questions = i18n.language === "en" ? questionsEn : questionsRo;
  console.log(i18n.language, "i18n.language");
  const [messages, setMessages] = useState([
    { type: "ai", message: questions[0].text, propertyCount: 0 },
  ]);
  const [userInput, setUserInput] = useState("");
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [responses, setResponses] = useState({});
  const [waitingForAPI, setWaitingForAPI] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [suggestions, setSuggestions] = useState(questions[0].suggestions);
  const [flag, setFlag] = useState(false);
  const [render, setRender] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingSuggestion, setLoadingSuggestion] = useState(false);
  const [suggestionBudgetPrice, setSuggestionBudgetPrice] = useState([]);
  const [loc, setLoc] = useState({
    preferredLocationLatitue: "",
    preferredLocationLongitude: "",
  });
  const inputRef = useRef(null);
  const placeSelectedRef = useRef(false);
  const bottomRef = useRef(null);

  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const { loginInfo } = useAuthStore();
  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleHistory = () => setIsOpenHistory(!isOpenHistory);
  const toggleSummary = () => setIsOpenSummary(!isOpenSummary);
  const { propertyInfo, updatePropertyInfo, removePropertyInfo } =
    usePropertyStore();

  const handleFocus = () => {
    inputRef.current?.focus();
  };

  const handleSendMessage = async () => {
    if (!userInput.trim() || waitingForAPI) return;

    const currentQuestion = questions[currentQuestionIndex];
    const updatedResponses = { ...responses, [currentQuestion.key]: userInput };
    setResponses(updatedResponses);
    setFlag(false);
    placeSelectedRef.current = false; // reset for next time

    const newMessages = [
      ...messages,
      { type: "user", message: userInput, propertyCount: resultCount },
    ];
    // let newMessages;
    // if (resultCount > 10) {
    //   // User's message
    //   newMessages = [
    //     ...messages,
    //     { type: "user", message: userInput, propertyCount: resultCount },
    //   ];
    // }
    // else{
    //   newMessages = [
    //     ...messages,
    //     { type: "user", message: "", propertyCount: resultCount },
    //   ];
    // }

    setSuggestions(questions[currentQuestionIndex + 1]?.suggestions);

    setUserInput("");

    if (currentQuestionIndex === 2) {
      updatePropertyInfo({
        ...propertyInfo,
        [currentQuestion.key]: {
          answer: userInput,
          latLng: {
            latitude: loc?.preferredLocationLatitue
              ? loc?.preferredLocationLatitue
              : "",
            longitude: loc?.preferredLocationLongitude
              ? loc?.preferredLocationLongitude
              : "",
          },
        },
      });
    } else {
      updatePropertyInfo({
        ...propertyInfo,
        // [currentQuestion.key]: { answer: userInput },
        [currentQuestion.key]: {
          answer: userInput,
          latLng: {
            latitude: "",
            longitude: "",
          },
        },
      });
    }

    // If the current question is "location", wait for API response first
    if (currentQuestion.key === "location") {
      setWaitingForAPI(true);
      const location = userInput; // Directly use the user input for location
      try {
        setToken(loginInfo ? loginInfo?.token : null);
      } catch (error) {
        console.warn("API Error:", error);
      } finally {
        setWaitingForAPI(false);
      }
    }

    // Now proceed with AI response and next question
    const aiResponse = {
      type: "ai",
      suggestions: [`${currentQuestion.label}: ${userInput}`],
    };
    newMessages.push(aiResponse);

    if (currentQuestionIndex < questions.length - 1) {
      const nextQuestion = questions[currentQuestionIndex + 1];
      newMessages.push({
        type: "ai",
        message: nextQuestion.text,
        label: nextQuestion?.label,
      });
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      newMessages.push({
        type: "ai",
        message: "Thanks! Here's what I gathered about your preferences:",
        suggestions: Object.entries(updatedResponses).map(([key, value]) => {
          const label = questions.find((q) => q.key === key)?.label || key;
          return `${label}: ${value}`;
        }),
        propertyCount: resultCount,
      });
    }

    setMessages(newMessages);
  };

  const navigate = useNavigate();
  const newChat = () => {
    removePropertyInfo();
    navigate("/");
  };

  const clickOnSuggestion = (suggestion) => {
    setUserInput(suggestion);
    setFlag(true);
  };
  const clickOnMultiSuggestion = (suggestion) => {
    setUserInput((prev) => {
      const suggestionsArray = prev
        ? prev.split(", ").map((s) => s.trim())
        : [];
      if (suggestionsArray.includes(suggestion)) {
        return prev; // If suggestion already exists, return the same value
      }
      return prev ? prev + ", " + suggestion : suggestion;
    });
  };

  //My login begins here
  const onSearchResults = async () => {
    try {
      // Check if suggestions array contains a location
      setToken(loginInfo ? loginInfo?.token : null);
      setLoading(true);
      let payload = {};
      scrollToBottom();
      payload = {
        location: {
          latLng: {
            latitude:
              currentQuestionIndex >= 0
                ? propertyInfo?.location?.latLng?.latitude
                : "",
            longitude:
              currentQuestionIndex >= 0
                ? propertyInfo?.location?.latLng?.longitude
                : "",
          },
          address:
            currentQuestionIndex >= 0 ? propertyInfo?.location?.address : "",
        },
        calculatedSize:
          currentQuestionIndex >= 0
            ? propertyInfo?.calculatedSize?.size?.length > 0
              ? propertyInfo?.calculatedSize?.size
              : [0, 0]
            : "",
        movePlan:
          currentQuestionIndex >= 1
            ? propertyInfo?.movePlan?.answer
              ? propertyInfo?.movePlan?.answer
              : ""
            : "",
        monthlyBudget:
          currentQuestionIndex >= 2
            ? propertyInfo?.budgetPricing?.answer
              ? propertyInfo?.budgetPricing?.answer
              : ""
            : "",
        preferredLocation:
          currentQuestionIndex >= 3
            ? propertyInfo?.preferredLocation
              ? propertyInfo?.preferredLocation
              : ""
            : "",
        officeType:
          currentQuestionIndex >= 4
            ? propertyInfo?.officeType?.answer
              ? propertyInfo?.officeType?.answer
              : ""
            : "",
        leaseTermsDuration:
          currentQuestionIndex >= 5
            ? propertyInfo?.leaseDuration?.answer
              ? propertyInfo?.leaseDuration?.answer
              : ""
            : "",
        // officeSpaces:
        //   currentQuestionIndex >= 6
        //     ? propertyInfo?.officeSpaces?.answer
        //       ? propertyInfo?.officeSpaces?.answer
        //       : ""
        //     : "",

        parking:
          currentQuestionIndex >= 6
            ? propertyInfo?.parking?.answer
              ? propertyInfo?.parking?.answer
              : ""
            : "",
        type: "",
      };

      const response = await filterPropertyAPI(payload);
      if (response?.data?.statusCode == 200) {
        setResultCount(response?.data?.count);
      } else {
        console.warn("error filter property in API gives 401");
      }
    } catch (error) {
      console.warn("error============", error);
    } finally {
      setLoading(false);
    }
  };

  const getMonthlyBudgetSuggestion = async () => {
    try {
      setToken(loginInfo ? loginInfo?.token : null);
      setLoadingSuggestion(true);
      let payload = {};
      payload = {
        calculatedSize:
          currentQuestionIndex >= 0
            ? propertyInfo?.calculatedSize?.size?.length > 0
              ? propertyInfo?.calculatedSize?.size
              : [0, 0]
            : [0, 0],
        language: i18n.language,
      };
      const response = await fetchBudgetPricing(payload);
      if (response?.data?.statusCode == 200) {
        setSuggestionBudgetPrice(response?.data?.suggestions);
      } else {
        console.warn("error filter property in API gives 401");
      }
    } catch (error) {
      console.warn("error============", error);
    } finally {
      setLoadingSuggestion(false);
    }
  };

  useEffect(() => {
    if (currentQuestionIndex === 1) {
      getMonthlyBudgetSuggestion();
    }
  }, [currentQuestionIndex]);

  useEffect(() => {
    onSearchResults();
  }, [render]);

  useEffect(() => {
    if (flag) {
      handleSendMessage();
    }
  }, [flag]);

  useEffect(() => {
    if (currentQuestionIndex !== 2) return;
    const input = document.getElementById("location1");
    if (!input || !propertyInfo?.location?.address) return;

    function initAutocomplete() {
      const geocoder = new window.google.maps.Geocoder();

      let locLatitude = propertyInfo.location.latLng.latitude;
      let locLongitude = propertyInfo.location.latLng.longitude;
      const center = new window.google.maps.LatLng(locLatitude, locLongitude);
      const bounds = new window.google.maps.LatLngBounds(
        new window.google.maps.LatLng(locLatitude - 0.05, locLongitude - 0.05),
        new window.google.maps.LatLng(locLatitude + 0.05, locLongitude + 0.05)
      );

      geocoder.geocode(
        { address: propertyInfo.location.address },
        (results, status) => {
          if (status === "OK" && results[0]) {
            const bounds =
              results[0].geometry.bounds || results[0].geometry.viewport;

            autocompleteRef.current =
              new window.google.maps.places.Autocomplete(input, {
                bounds,
                strictBounds: true,
                componentRestrictions: { country: "ro" },
              });

            autocompleteRef.current.addListener("place_changed", () => {
              const place = autocompleteRef.current.getPlace();

              if (!place.geometry) {
                input.value = "";
                return;
              }

              const latitude = place.geometry.location.lat();
              const longitude = place.geometry.location.lng();
              setFlag(false);
              setUserInput(input.value);
              setLoc({
                ...loc,
                preferredLocationLatitue: latitude,
                preferredLocationLongitude: longitude,
              });

              // ✅ Mark place as selected
              placeSelectedRef.current = true;
            });
          } else {
            console.error("Geocode was not successful: " + status);
          }
        }
      );
    }

    if (window.google?.maps?.places) {
      initAutocomplete();
    } else {
      const existingScript = document.querySelector(
        "script[src*='maps.googleapis.com/maps/api/js']"
      );
      if (!existingScript) {
        const script = document.createElement("script");
        script.src =
          "https://maps.googleapis.com/maps/api/js?key=AIzaSyAd9DtfFUBGewec4qlO1SBG9NjLO4nLu34&libraries=places";
        script.async = true;
        document.body.appendChild(script);
        script.addEventListener("load", initAutocomplete);
      } else {
        initAutocomplete(); // already loaded
      }
    }

    return () => {
      if (autocompleteRef.current) {
        window.google.maps.event.clearInstanceListeners(
          autocompleteRef.current
        );
        autocompleteRef.current = null;
      }
    };
  }, [currentQuestionIndex, propertyInfo?.location?.address]);

  // useEffect(() => {
  //   console.log("resultCount==============", resultCount);
  //   console.log("currentQuestionIndex==============", currentQuestionIndex);
  //   // if (resultCount <= 10 && resultCount>0) {
  //   //   // const msg=messages
  //   //   // msg.pop()
  //   //   setMessages((prev)=>{console.log("-------------------prev------------",prev)})
  //   // }

  //   if (resultCount <= 10 && resultCount > 0 && messages?.length > 0) {
  //     setMessages((prevMessages) => {
  //       console.log("prevMessages=====================================",prevMessages)
  //       const updated = [...prevMessages.slice(0, -1)];
  //       console.log("Updated messages:", updated);
  //       return updated;
  //     });
  //   }
  // }, [resultCount]);

  console.log("=======|| currentQuestionIndex==", currentQuestionIndex);
  useEffect(() => {
    if (resultCount <= 10 && resultCount > 0 && messages.length > 0) {
      const updatedMessages = messages.slice(0, -1); // copy without last item
      setMessages(updatedMessages);
    }
  }, [resultCount]);
  console.log("messages==============", messages);

  return (
    <div className="mt-3">
      <div className="flex flex-row-reverse">
        <div className="mx-auto container lg:mt-8 mt-4">
          <div className="w-full"></div>
          <div className="md:text-right flex items-center justify-end gap-3">
            <button
              onClick={toggleSummary}
              className="bg-red-600 text-white py-2 px-4 rounded-[58px] font-semibold block lg:hidden"
            >
              {/* View Summary */}
              {t("view_summary")}
            </button>
            <button
              onClick={toggleHistory}
              className="bg-red-600 text-white py-2 px-4 rounded-[58px] font-semibold"
            >
              {/* View History */}
              {t("view_history")}
            </button>
          </div>

          <h1 className="gradient-text text-4xl font-bold mt-3">
            {t("text_hi")}{" "}
            {loginInfo?.user?.fullname ? loginInfo?.user?.fullname : ""},{" "}
            {t("text_greeting_short")}
          </h1>

          <h4 className="text-lg text-[#5D5D5D] font-semibold mt-2">
            {t("text_greeting_first")}
            {t("text_greeting_second")}:
          </h4>

          <div className="xl:min-h-[10vh] 2xl:min-h-[0vh]">
            {messages?.map((msg, index) =>
              msg.type === "user" ? (
                <UserMessage key={index} message={msg.message} />
              ) : (
                <>
                  <AiMessage
                    resultCount={resultCount}
                    key={index}
                    message={msg.message}
                    suggestions={msg.suggestions}
                    allMessages={messages}
                    currentQuestionIndex={currentQuestionIndex}
                    newMessage={newMessage}
                    setNewMessage={setNewMessage}
                    setRender={setRender}
                    render={render}
                    questions={questions}
                  />
                </>
              )
            )}
          </div>

          <div className="bg-white bottom-0 right-0 p-4 mt-6">
            {resultCount > 10 && (
              <div className="flex gap-3 flex-wrap justify-center mb-2">
                {currentQuestionIndex !== 1
                  ? suggestions?.map((item, index) => (
                      <button
                        className="border text-xs md:text-base  border-[#E5EAF1] text-[#3C4043] font-semibold rounded-[58px] px-3 py-2"
                        onClick={() => {
                          if (currentQuestionIndex === 2) {
                            if (
                              item ==
                              "Specific district or area (please specify)"
                            ) {
                              handleFocus();
                            } else {
                              clickOnSuggestion(item);
                            }
                          } else {
                            clickOnSuggestion(item);
                          }
                        }}
                        key={index}
                      >
                        {item}
                      </button>
                    ))
                  : suggestionBudgetPrice?.map((item, index) => (
                      <button
                        className="border text-xs md:text-base  border-[#E5EAF1] text-[#3C4043] font-semibold rounded-[58px] px-3 py-2"
                        onClick={() => {
                          if (currentQuestionIndex === 2) {
                            if (
                              item ==
                                "Specific district or area (please specify)" ||
                              item == "Open to suggestions"
                            ) {
                              handleFocus();
                            } else {
                              clickOnSuggestion(item);
                            }
                          } else {
                            clickOnSuggestion(item);
                          }
                        }}
                        key={index}
                      >
                        {loadingSuggestion ? (
                          <div className="flex">
                            <ClipLoader size={20} color="red" />
                          </div>
                        ) : (
                          `${item}`
                        )}
                      </button>
                    ))}
              </div>
            )}

            <div className="flex gap-3">
              <div className="relative w-full">
                {currentQuestionIndex !== 2 ? (
                  <input
                    type="text"
                    className="w-full border border-[#DEDEDE] pr-14 bg-[#F4F4F4] text-base focus:outline-none rounded-[96px] p-3"
                    placeholder="Tell me about your dream office"
                    value={userInput}
                    // ref={inputRef}
                    disabled={
                      currentQuestionIndex == questions.length - 1
                        ? true
                        : resultCount <= 10
                        ? true
                        : false
                    }
                    onChange={(e) => setUserInput(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
                    id="noMap"
                    autoComplete="off"
                  />
                ) : (
                  <>
                    <input
                      type="text"
                      className="w-full border border-[#DEDEDE] pr-14 bg-[#F4F4F4] text-base focus:outline-none rounded-[96px] p-3"
                      // placeholder="Tell me about your dream office"
                      placeholder={t("calculator_enter_city")}
                      value={userInput}
                      ref={inputRef}
                      disabled={
                        currentQuestionIndex == questions.length - 1
                          ? true
                          : resultCount <= 10
                          ? true
                          : false
                      }
                      onChange={(e) => setUserInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          if (currentQuestionIndex === 2) {
                            // If Enter is pressed but place hasn't been selected yet
                            if (!placeSelectedRef.current) {
                              e.preventDefault(); // prevent premature submission
                              return;
                            }
                          }

                          handleSendMessage();
                        }
                      }}
                      id="location1"
                      autoComplete="off"
                    />
                  </>
                )}
                {/* <input
                type="text"
                className="w-full border border-[#DEDEDE] pr-14 bg-[#F4F4F4] text-base focus:outline-none rounded-[96px] p-3"
                placeholder="Tell me about your dream office"
                value={userInput}
                ref={inputRef}
                disabled={currentQuestionIndex == questions.length - 1}
                onChange={(e) => setUserInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
              /> */}
                <button
                  onClick={handleSendMessage}
                  disabled={currentQuestionIndex == questions.length - 1}
                  className="absolute top-[5px] right-2 bg-red-600 rounded-full"
                >
                  <img
                    src={SendIcon}
                    alt="Send"
                    className="w-[40px] h-[40px]"
                  />
                </button>
              </div>

              {/* {currentQuestionIndex == questions.length - 1 && (
              <button
                onClick={newChat}
                className="bg-red-600 text-white py-2 px-4 min-w-[130px] rounded-[58px] font-semibold"
              >
                New Chat
              </button>
            )} */}
            </div>
          </div>

          <div
            ref={bottomRef}
            className="flex justify-around py-3 flex-col sm:flex-row bg-white z-[1] sticky sm:static bottom-0 sm:max-h-full max-h-[150px] overflow-auto"
          >
            <ul className="text-primary-text font-medium text-base mt-2">
              {propertyInfo?.location &&
                propertyInfo?.location?.address !== "" &&
                currentQuestionIndex >= 0 && (
                  <li>
                    ✅ {t("location")}: {propertyInfo?.location?.address}
                  </li>
                )}

              {propertyInfo?.calculatedSize?.size?.length !== 0 &&
                currentQuestionIndex >= 0 && (
                  <li>
                    ✅ {t("space")}: {propertyInfo?.calculatedSize?.size[0]}m² -{" "}
                    {propertyInfo?.calculatedSize?.size[1]}m² {t("added")}.
                  </li>
                )}

              {/* need to update formula according to given requirement */}
              {propertyInfo?.employeesPerArea > 0 && (
                <li>
                  ✅ {t("number_of_people")}:{" "}
                  {propertyInfo?.calculatedSize?.size[0]
                    ? propertyInfo?.employeesPerArea
                    : 0}{" "}
                  m²/{t("text_person")}.
                </li>
              )}

              {propertyInfo?.movePlan &&
                propertyInfo?.movePlan?.answer !== "" &&
                currentQuestionIndex >= 1 && (
                  <li>
                    ✅ {t("plan_to_move")}: {propertyInfo?.movePlan?.answer}
                  </li>
                )}

              {propertyInfo?.budgetPricing &&
                propertyInfo?.budgetPricing?.answer !== "" &&
                currentQuestionIndex >= 2 && (
                  <li>
                    ✅ {t("budget_pricing")}:{" "}
                    {propertyInfo?.budgetPricing?.answer}
                  </li>
                )}

              {propertyInfo?.preferredLocation &&
                propertyInfo?.preferredLocation?.answer !== "" &&
                currentQuestionIndex >= 3 && (
                  <li>
                    ✅ {t("preferred_location")}:{" "}
                    {propertyInfo?.preferredLocation?.answer}
                  </li>
                )}

              {propertyInfo?.officeType &&
                propertyInfo?.officeType?.answer !== "" &&
                currentQuestionIndex >= 4 && (
                  <li>
                    ✅ {t("office_type")}: {propertyInfo?.officeType?.answer}
                  </li>
                )}

              {propertyInfo?.leaseDuration &&
                propertyInfo?.leaseDuration.answer !== "" &&
                currentQuestionIndex >= 5 && (
                  <li>
                    ✅ {t("lease_duration")}:{" "}
                    {propertyInfo?.leaseDuration?.answer}
                  </li>
                )}

              {/* {propertyInfo?.officeSpaces &&
                propertyInfo?.officeSpaces?.answer !== "" &&
                currentQuestionIndex >= 6 && (
                  <li>
                    ✅ Office spaces: {propertyInfo?.officeSpaces?.answer}
                  </li>
                )} */}

              {propertyInfo?.parking &&
                propertyInfo?.parking?.answer !== "" &&
                currentQuestionIndex >= 6 && (
                  <li>
                    ✅ {t("parking")}: {propertyInfo?.parking?.answer}
                  </li>
                )}
            </ul>

            {/* {newMessage && ( */}
            {resultCount <= 10 ? (
              <div className="text-center mt-3 mb-8">
                <Link
                  to={
                    i18n.language === "en"
                      ? `/en/office-space?index=${currentQuestionIndex}`
                      : `/office-space?index=${currentQuestionIndex}`
                  }
                >
                  <button className="text-red-600 font-medium border border-red-600 py-2 px-8 rounded-[58px]">
                    {loading ? (
                      <div className="flex">
                        <ClipLoader size={20} color="red" />
                      </div>
                    ) : (
                      <>
                        {t("text_see")} {resultCount} {t("text_results")}
                      </>
                    )}
                  </button>
                </Link>
              </div>
            ) : currentQuestionIndex == 6 ? (
              <div className="text-center mt-3 mb-8">
                <Link
                  to={
                    i18n.language === "en"
                      ? `/en/office-space?index=${currentQuestionIndex}`
                      : `/office-space?index=${currentQuestionIndex}`
                  }
                >
                  <button className="text-red-600 font-medium border border-red-600 py-2 px-8 rounded-[58px]">
                    {loading ? (
                      <div className="flex">
                        <ClipLoader size={20} color="red" />
                      </div>
                    ) : (
                      <>
                        {t("text_see")} {resultCount} {t("text_results")}
                      </>
                    )}
                  </button>
                </Link>
              </div>
            ) : (
              <div className="text-center mt-3 mb-8">
                {/* <Link to={`/office-space?index=${currentQuestionIndex}`}> */}
                <button className="text-red-600 font-medium border border-red-600 py-2 px-8 rounded-[58px]">
                  {loading ? (
                    <div className="flex">
                      <ClipLoader size={20} color="red" />
                    </div>
                  ) : (
                    <>
                      {t("text_see")} {resultCount} {t("text_results")}
                    </>
                  )}
                </button>
                {/* </Link> */}
              </div>
            )}

            {/* )} */}
          </div>
        </div>
        {/* <Drawer open={true} onClose={toggleMenu} direction="left">
        <SummarySection currentQuestionIndex={currentQuestionIndex} />
      </Drawer> */}
        <Drawer open={isOpenHistory} onClose={toggleHistory} direction="left">
          <HistorySection />
        </Drawer>
        <div className="hidden lg:block">
          <SummarySection currentQuestionIndex={currentQuestionIndex} />
        </div>
        <Drawer open={isOpenSummary} onClose={toggleSummary} direction="left">
          <SummarySection currentQuestionIndex={currentQuestionIndex} />
        </Drawer>
      </div>
    </div>
  );
};

export default AiChatSection;
